import Vue from 'vue'
import VeeValidate, {ValidationObserver, ValidationProvider, Validator,} from 'vee-validate'
import ru from 'vee-validate/dist/locale/ru'
import * as rules from 'vee-validate/dist/rules.esm'

Object.keys(rules).forEach(rule => {
    Validator.extend(rule, rules[rule]);
});

Validator.extend('ogrn', {
    validate: value => value.toString().length === 13 || value.toString().length === 15
});
Validator.extend('inn', {
    validate: value => value.toString().length === 10 || value.toString().length === 12
});
Validator.extend('date', {
    validate: value => {
        return !!value.match(/^\d{2}([./-])\d{2}\1\d{4}$/) // dd (separator) mm (separator) yyyy
            || !!value.match(/^\d{4}([./-])\d{2}\1\d{2}$/) // yyyy (separator) mm (separator) dd
    }
});
Validator.extend('time', {
    validate: value => {
        if (value.length !== 8) return false
        const timeComponents = value.split(':')
        if (timeComponents.length !== 3) return false
        return parseInt(timeComponents[0], 10) >= 0
            && parseInt(timeComponents[0], 10) < 24
            && parseInt(timeComponents[1], 10) >= 0
            && parseInt(timeComponents[1], 10) < 60
            && parseInt(timeComponents[2], 10) >= 0
            && parseInt(timeComponents[2], 10) < 60
    }
});
Validator.extend('phone', {
    validate: value => {
        return !!value.match(/^(8|[\+]?7)\d{10}$/)
    }
});

const dictionary = {
    ru: {
        messages: {
            ogrn: field => 'Поле ' + field + ' должно содержать 13 или 15 цифр',
            inn: field => 'Поле ' + field + ' должно содержать 10 или 12 цифр',
            date: 'Используйте корректный формат даты',
            time: 'Укажите корректное время',
            required_if: field => 'Поле ' + field + ' обязательно для заполнения',
            digits: (field, [length]) => {
                const plural = require("plural-ru")
                const pluralDigits = plural(length, 'цифра', 'цифры', 'цифр')
                return `Поле ${field} должно содержать ${length} ${pluralDigits}`
            },
            phone: 'Поле должно быть вида +71234567890 или 81234567890'
        },
        attributes: {
            person: 'ФИО',
            person_phone: 'телефон',
            new_password: '"Новый пароль"',
            password: '"Пароль"',
        },
    }
};

Validator.localize("ru", ru);
Validator.localize(dictionary);

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.use(VeeValidate, {
    locale: "ru",
    inject: true, // TODO Удалить inject во все компоненты
    fieldsBagName: 'veeFields' //Иначе будут ошибки про fields
});
